module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-panel/admin-panel.component.css
// module id = ./src/app/admin-panel/admin-panel.component.css
// module chunks = main